import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPSelfSignificator ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Self Significators');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/planetarycuspalpositionchart/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );
  }, [userData]);

  const tdwidth = {
    width: "12.5%",
  };

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
          <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Self Significators</h5></caption>
          <thead>
            <tr class="p-0 m-0">
              <th class="p-1 kptable-td">Planet</th> 
              <th class="p-1 kptable-td" style={tdwidth}>Sign Lord</th> 
              <th class="p-1 kptable-td" style={tdwidth}>Star Lord</th> 
              <th class="p-1 kptable-td" style={tdwidth}>Sub Lord</th> 
              <th class="p-1 kptable-td" style={tdwidth}>CL</th> 
              <th class="p-1 kptable-td" style={tdwidth}>OCC</th> 
              <th class="p-1 kptable-td" style={tdwidth}>CST</th> 
              <th class="p-1 kptable-td" style={tdwidth}>CSL</th> 
            </tr>
          </thead>
          <tbody>
            {chartData.map((planet) => (
                  <tr class="p-0 m-0"  onClick={handleClickColor}>
                      <th class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[0]}</th>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[1]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[2]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[3]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[5]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[6]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[7]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[8]}</td>
                  </tr>
              ))}
          </tbody>  
          </table>
          </>
          )
        }
        </>
      );
  }